/**
 * The disclosure sentence the Amazon Associates Operating Agreement requires,
 * verbatim.
 *
 * §5, "Identifying Yourself as an Associate", re-fetched live from
 * https://affiliate-program.amazon.com/help/operating/agreement on 2026-08-16:
 *
 *   "You must clearly and prominently state the following, or any
 *    substantially similar statement previously allowed under this Agreement,
 *    on your Site or any other location where Amazon may authorize your
 *    display or other use of Program Content: 'As an Amazon Associate I earn
 *    from qualifying purchases.'"
 *
 * DO NOT EDIT THE STRING. Not the wording, not the punctuation, not the first
 * person — "I" reads oddly for a company and is Amazon's text regardless, and
 * the same section forbids embellishing the relationship. A copy edit here is
 * a contract change. `src/pages/__tests__/brand-wording.test.tsx` pins it for
 * exactly that reason, in the same place the repo already pins the
 * accusation/timing wording.
 *
 * A constant rather than a literal in each surface because it appears in three
 * places (the sitewide footer, the terms of service, and beside the outbound
 * links on the results page) and three hand-typed copies is three chances to
 * drift out of verbatim.
 *
 * Re-verify against the live agreement whenever this file is touched; Amazon
 * revises it, and the "substantially similar statement previously allowed"
 * clause only covers wording Amazon itself has allowed before, not ours.
 */
export const AMAZON_ASSOCIATES_DISCLOSURE =
  "As an Amazon Associate I earn from qualifying purchases.";
